import { connect } from 'react-redux'
import TitleSlideEditDialog from './edit-dialog.jsx'
import {
  getSlide,
  getUpdateSlideRequest
} from '../../../../stores/presentation/presentation.selectors'
import { updateSlide } from '../../../../stores/presentation/presentation.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getEditSlideDialog } from '../../../pages/lesson/builder/redux/builder.selectors.js'
import { closeEditSlideDialog } from '../../../pages/lesson/builder/redux/builder.actions.js'

const mapStateToProps = state => {
  const edistSlideDialog = getEditSlideDialog(state)
  const slide = getSlide(state, edistSlideDialog.slideId)
  if (!slide) return { modalOpened: false }
  const updateSlideRequest = getUpdateSlideRequest(state, slide.id)
  return {
    modalOpened: edistSlideDialog.opened && edistSlideDialog.type === 'Title',
    title: slide.title,
    id: slide.id,
    updating: updateSlideRequest.pending
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onClose: () => dispatch(closeEditSlideDialog()),
  onSubmit: values =>
    dispatch(
      updateSlide(stateProps.id, 'title', { title: values.title })
    ).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(TitleSlideEditDialog)
